export default {
  'accessories.general.form.description': 'Descrição do Acessório',
  'accessories.modal.remove.title': 'Remover acessório',
  'accessories.modal.remove.content': 'Deseja remover o acessório',
  'accessories.modal.remove.button.ok': 'Remover',
  'accessories.modal.remove.message.success': 'Acessório removido com sucesso!',
  'accessories.modal.remove.message.error':
    'Não foi possível remover o acessório!',
  'accessories.page.button.new': 'Novo Acessório',
  'accessories.modal.create.title': 'Adicionar Acessório',
  'accessories.modal.edit.title': 'Atualizar Acessório',
  'accessories.modal.create.message.success':
    'Acessório adicionado com sucesso!',
  'accessories.modal.edit.message.success': 'Acessório atualizado!',
  'accessories.modal.message.error': 'Não foi possível executar a açao!',
  'accessories.modal.checklist': 'Checklist',

  'accessories.status.message.success':
    'Status do Acessório alterado com sucesso!',
};
